import { Link } from 'react-router-dom';
import { useCompanyLogo } from '../hooks/useCompanyLogo';
import { useNavigationGuard } from '../contexts/NavigationGuardContext';

/** Company logo centered in the app-shell mobile toolbar. */
export const MobileNavLogo = () => {
    const companyLogo = useCompanyLogo();
    const { tryNavigate } = useNavigationGuard();

    return (
        <Link
            to="/"
            className="mobile-nav-logo-link"
            aria-label="Home"
            onClick={(event) => {
                event.preventDefault();
                tryNavigate('/');
            }}
        >
            <img
                src={companyLogo || '/logo-images/teiq-logo.png'}
                alt=""
                className="mobile-nav-logo"
                aria-hidden="true"
            />
        </Link>
    );
};
